/**
 * Panda Panic (spec 15 §5 + games/panda-panic.md H8) : préversion gatée par un
 * flag de build OFF par défaut. Tant que `VITE_GAME_PANDA_PANIC` n'est pas `on`,
 * la route n'est pas enregistrée (404) et aucune carte n'apparaît sur le hub —
 * la prod n'est pas impactée. Activation : Phase 5 (décision humaine).
 * Lu paresseusement (les tests le stubbent via `vi.stubEnv`).
 */
export function isPandaPanicEnabled(): boolean {
  return import.meta.env.VITE_GAME_PANDA_PANIC === 'on';
}

/**
 * Mode EN LIGNE (Phase 4, spec jeu §12.4) : gaté par un flag DISTINCT
 * `VITE_GAME_PANDA_PANIC_ONLINE`, off par défaut. Le multijoueur exige un serveur
 * autoritaire déployé (`apps/game-server` + proxy `wss:///game`) : tant que ce
 * flag n'est pas `on`, les routes online ne sont pas enregistrées et aucun accès
 * au lobby n'est proposé — la préversion locale reste seule visible (prod
 * intacte). Activation : décision humaine (infra en place, cf. HUMAN_TODO).
 */
export function isPandaPanicOnlineEnabled(): boolean {
  return import.meta.env.VITE_GAME_PANDA_PANIC_ONLINE === 'on';
}
